<div *ngIf="!isViewMode" [formGroup]="form">
  <div class="related-news-list">
    <div *ngFor="let news of relatedNews; let i = index; let last = last" class="news-item d-flex justify-content-between align-items-center" [ngClass]="{'last-news-item': last}">
      <a (click)="onRelatedNewsClick(news.id)" class="news-link">{{ news.title }}</a>
      <button class="btn btn-link p-0" (click)="deleteNews(i)">
        <i class="bi bi-dash-circle-fill"></i>
      </button>
    </div>
    <div class="dropdown-container d-flex align-items-center">
      <app-select-form-field
        *ngIf="showDropdown"
        formControlName="relatedNewsDropdown"
        [label]="'label.select_related_news' | translate"
        [items]="availableNewsItems"
        [bindLabel]="'title'"
        [bindValue]="'id'"
        [users]="false"
        (onSelectEvent)="onSelectRelatedNews($event)"
        class="dropdown-field"
      ></app-select-form-field>
    </div>
  </div>
</div>

<div *ngIf="isViewMode" class="container-fluid">
  <div class="row">
    <div class="col-12 mb-3" *ngFor="let news of relatedNews">
      <app-case-form-section-container class="related-view" [title]="news.title">
        <p [innerHTML]="news.shortBody"></p>
        <div class="details d-flex flex-column flex-md-row justify-content-between">
          <div class="author">{{ news.autorName }}</div>
          <div class="date text-end mt-2 mt-md-0">
            {{ news.viewsCount }} views
            <span class="separator">&bull;</span>
            {{ news.publishDate |  date: 'MMM d, y • HH:mm'  }}
          </div>
        </div>
      </app-case-form-section-container>
    </div>
  </div>
</div>
